import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { ShoppingBag } from 'lucide-react'; // ✅ Import shopping bag icon from Lucide

const Header = () => {
  const { items } = useSelector(state => state.page);

  return (
    <div className="flex items-center justify-between px-6 py-2 bg-white shadow-md">
      
      <div className="flex gap-6 text-lg font-medium">
        <Link to="/" className="hover:text-blue-500 transition">Home</Link>
        <Link to="/products" className="hover:text-blue-500 transition">Products</Link>
      </div>

      
      <Link to="/shoppingpage" className="relative flex items-center gap-2 text-lg font-medium hover:text-blue-500 transition">
        <ShoppingBag size={24} /> {/* ✅ Bag Icon */}
        {items.length > 0 && (
          <span className="absolute -top-2 -right-2 bg-red-500 text-white text-xs font-bold w-5 h-5 flex items-center justify-center rounded-full">
            {items.reduce(
  (accumulator, currentValue) => accumulator + currentValue.quantity,
  0,)}
          </span>
        )}
      </Link>
    </div>
  );
};

export default Header;
